<template>
  <div>
    <yn-with-title title="Import topic">
      <yn-import-topic :id="$route.params.id" />
    </yn-with-title>
    <hr />
    <yn-with-title title="Export topic">
      <yn-export-topic :id="$route.params.id" />
    </yn-with-title>
  </div>
</template>

<script>
import WithTitle from '@/components/common/_WithTitle';
import ImportTopic from '@/components/management/ImportTopic';
import ExportTopic from '@/components/management/ExportTopic';

export default {
  components: {
    'yn-import-topic': ImportTopic,
    'yn-export-topic': ExportTopic,
    'yn-with-title': WithTitle
  }
};
</script>

<style scoped>
hr {
  margin: 2rem 0;
}
</style>
